(function () {
	'use strict';

	angular
		.module('wizard-english-test')
		.controller('QuizController', QuizController)

	/** @ngInject */
	function QuizController($state, $timeout, $sce, HelperService, NotifyService, QuestionService, TestProgressService, sweetAlert, APP) {
		const vm = this;
		let leadData;

		vm.submitAnswer = () => {
			if (!vm.currentAlternative || !vm.currentAlternative.Id) {
				NotifyService.error("Selecione uma alternativa!");
				return
			}

			if (vm.currentQuestion.Question && vm.currentQuestion.Question.AudioUrlComplete) {
				vm.showAudioPlayer = false;
			}

			HelperService.startLoading(".app-body", "Enviando resposta...");

			let answerData = {
				LeadCode: leadData.Code,
				QuestionId: vm.currentAlternative.QuestionId,
				AlternativeId: vm.currentAlternative.Id
			}

			postAnswer(answerData)
				.then(
					success => successCallbackQuestion(success),
					error => errorCallback(error.data.ErrorMessage, vm.submitAnswer)
				)
		}

		vm.finishTestCallback = (endTestMessage) => {
			vm.currentQuestion = null;
			leadData.IsFinished = true;

			HelperService.saveToLocalStorage(APP.LEAD_LOCAL_DATA, leadData);

			$timeout(() => {
				HelperService.stopLoading(".app-body");

				$state.go("app.result", {
					endTestMessage: endTestMessage
				});
			}, 1500)
		}

		vm.closeQuizMessage = () => vm.openedQuizMessage = false;

		vm.renderQuestionHtml = value => value.replace("\r\n", "<br><br>");

		init();

		function getLocalLeadData() {
			leadData = HelperService.getFromLocalStorage(APP.LEAD_LOCAL_DATA);
		}

		function successCallbackQuestion(successData) {
			$timeout(() => HelperService.stopLoading(".app-body"), 1500);

			vm.currentQuestion = successData;
			vm.openedQuizMessage = (vm.currentQuestion.Note) ? true : false;
			vm.showAudioPlayer = vm.currentQuestion.Question && vm.currentQuestion.Question.AudioUrlComplete ? true : false;

			leadData.IsFinished = false;
			HelperService.saveToLocalStorage(APP.LEAD_LOCAL_DATA, leadData);

			if (vm.currentQuestion.IsFinished == false && vm.currentQuestion.Question && vm.currentQuestion.Question && vm.currentQuestion.Question.Active == true) {
				vm.currentAlternative = {};
			} else if (successData.IsFinished == true) {
				let endTestMessage = (vm.currentQuestion.Note) ? vm.currentQuestion.Note : "Sucesso! Você finalizou o teste!";
				vm.finishTestCallback(endTestMessage);
			} else
				errorCallback(successData.ErrorMessage, vm.submitAnswer)

			return;
		}

		function finishTest() {
			sweetAlert
				.swal({
					title: "SUCESSO!",
					type: "success",
					text: "Você finalizou o teste!",
					confirmButtonText: "Continuar",
					showCancelButton: false
				})
				.then(value => {
					if (value == true) {

					}
				})
		}

		function errorCallback(message, callbackFunction) {
			HelperService.stopLoading(".app-body");

			let isDevelopment = HelperService.isDevelopment();
			let errorMessage = message || "Ocorreu um erro inesperado. Por favor, tente novamente.";

			if (isDevelopment)
				errorMessage += `<br><br><small><strong>Informe esse código: ${leadData.Code}</strong></small>`;

			sweetAlert
				.swal({
					title: "ERRO!",
					type: "error",
					html: errorMessage,
					confirmButtonText: "Tentar novamente",
					showCancelButton: true,
					cancelButtonText: "Voltar",

				})
				.then(value => {
					if (value == true)
						callbackFunction()
				})
		}

		function startQuiz() {
			HelperService.startLoading(".app-body", "Obtendo pergunta...");

			getQuestion()
				.then(
					success => successCallbackQuestion(success),
					error => errorCallback(error.data.ErrorMessage, startQuiz)
				)
		}

		function getQuestion() {
			return QuestionService.getQuestion(leadData.Code);
		}

		function postAnswer(answerData) {
			return TestProgressService.postTestProgress(answerData);
		}

		function init() {
			vm.currentQuestion = {};
			vm.currentAlternative = {};
			vm.openedQuizMessage = false;
			vm.showAudioPlayer = false;

			getLocalLeadData();

			if (!leadData) {
				$state.go("app.home");
				return
			}

			startQuiz();
		}
	}
}());